<template>
  <div class="table-container">
    <!-- 导航查询模板 -->
    <el-row :gutter="20">
      <el-col :xs="24"
              :sm="24"
              :md="12"
              :lg="24"
              :xl="24">
        <el-card>
          <el-button icon="el-icon-search"
                     plain
                     native-type="submit"
                     @click="handleQuery">
            查询
          </el-button>
          <el-button icon="el-icon-refresh-left"
                     type="info"
                     plain
                     native-type="submit"
                     @click="resetForm('queryForm')">
            重置
          </el-button>
          <el-button icon="el-icon-sort"
                     plain
                     native-type="submit"
                     @click="heightQuery">
            高级筛选
          </el-button>

          <el-form ref="queryForm"
                   :model="queryForm"
                   style="margin-top: 15px"
                   class="demo-form-inline my-form-class">
            <el-row :gutter="20">
              <el-col :xs="24"
                      :sm="24"
                      :md="12"
                      :lg="6"
                      :xl="6">
                <!-- 请选择流转日期范围 -->
                <el-form-item prop="circulationTime">
                  <el-date-picker v-model="queryForm.circulationTime"
                                  type="daterange"
                                  unlink-panels
                                  range-separator="至"
                                  start-placeholder="流转开始日期"
                                  end-placeholder="流转结束日期"
                                  :picker-options="pickerOptions"
                                  clearable></el-date-picker>
                </el-form-item>
              </el-col>

              <el-col :xs="24"
                      :sm="24"
                      :md="12"
                      :lg="6"
                      :xl="6">
                <el-form-item prop="workOrderNo">
                  <el-input v-model.number="queryForm.workOrderNo"
                            placeholder="工单编号"></el-input>
                </el-form-item>
              </el-col>
              <!-- 目标主体 -->
              <el-col :xs="24"
                      :sm="24"
                      :md="12"
                      :lg="6"
                      :xl="6">
                <el-form-item prop="targetSubject">
                  <el-input v-model.trim="queryForm.targetSubject"
                            placeholder="目标主体"></el-input>
                </el-form-item>
              </el-col>
              <!-- 项目 -->
              <el-col :xs="24"
                      :sm="24"
                      :md="12"
                      :lg="6"
                      :xl="6">
                <el-form-item prop="projectId">
                  <el-cascader :value="queryForm.projectId"
                               :options="projectInfo"
                               clearable
                               :filterable="true"
                               separator=":"
                               placeholder="项目"
                               @change="handleProjectChange"></el-cascader>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-show="isShow"
                    transiton="fade"
                    :gutter="20">
              <!-- 初审日期范围 -->
              <el-col :xs="24"
                      :sm="24"
                      :md="12"
                      :lg="6"
                      :xl="6">
                <el-form-item prop="startScopeDate">
                  <el-date-picker v-model="queryForm.firstAuditDate"
                                  type="daterange"
                                  unlink-panels
                                  range-separator="至"
                                  start-placeholder="初审开始日期"
                                  end-placeholder="初审结束日期"
                                  :picker-options="pickerOptions"></el-date-picker>
                </el-form-item>
              </el-col>
              <!-- 选择地区 -->
              <el-col :xs="24"
                      :sm="24"
                      :md="12"
                      :lg="6"
                      :xl="6">
                <el-form-item prop="selectedOptions">
                  <el-cascader v-model="queryForm.address"
                               :filterable="true"
                               :options="cityInfo"
                               :clearable="true"
                               separator="/"
                               placeholder="地区"
                               :props="{ checkStrictly: true }"
                               @change="handleBlockChange"></el-cascader>
                </el-form-item>
              </el-col>
              <!--操作状态-->
              <el-col :xs="24"
                      :sm="24"
                      :md="12"
                      :lg="6"
                      :xl="6">
                <el-form-item prop="operStatus">
                  <el-select v-model="queryForm.operStatus"
                             placeholder="操作状态"
                             clearable
                             filterable>
                    <el-option v-for="item in operStatus"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <!-- 工单状态 -->
              <el-col :xs="24"
                      :sm="24"
                      :md="12"
                      :lg="6"
                      :xl="6">
                <el-form-item prop="workOrderStatus">
                  <el-select v-model="queryForm.workOrderStatus"
                             placeholder="工单状态"
                             clearable
                             filterable>
                    <el-option v-for="item in orderStatusOptions"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row v-show="isShow"
                    transiton="fade"
                    :gutter="20">
              <el-col :xs="24"
                      :sm="24"
                      :md="12"
                      :lg="6"
                      :xl="6">
                <!-- 下单日期范围  -->
                <el-form-item prop="orderDate">
                  <el-date-picker v-model="queryForm.orderDate"
                                  type="daterange"
                                  unlink-panels
                                  range-separator="至"
                                  start-placeholder="下单开始日期"
                                  end-placeholder="下单结束日期"
                                  :picker-options="pickerOptions"></el-date-picker>
                </el-form-item>
              </el-col>

              <!-- 选择人员 所有角色+名字（二级联动） -->
              <el-col :xs="24"
                      :sm="24"
                      :md="12"
                      :lg="6"
                      :xl="6">
                <el-form-item prop="userInfo">
                  <el-cascader :value="queryForm.userInfo"
                               :options="staffInfo"
                               clearable
                               :filterable="true"
                               separator=" "
                               placeholder="选择人员"
                               @change="handleSatffChange"></el-cascader>
                </el-form-item>
              </el-col>
              <!-- 订单编号 -->
              <el-col :xs="24"
                      :sm="24"
                      :md="12"
                      :lg="6"
                      :xl="6">
                <el-form-item prop="brWorkNo">
                  <el-input v-model.trim="queryForm.brWorkNo"
                            placeholder="订单编号"
                            clearable
                            @keyup.enter.native="handleQuery"></el-input>
                </el-form-item>
              </el-col>
              <!-- 报告类型 -->
              <el-col :xs="24"
                      :sm="24"
                      :md="12"
                      :lg="6"
                      :xl="6">
                <el-form-item prop="reportType">
                  <el-select v-model="queryForm.reportType"
                             placeholder="报告类型"
                             clearable
                             filterable>
                    <el-option v-for="item in reportType"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- 项目来源 -->
              <el-col :xs="24"
                      :sm="24"
                      :md="12"
                      :lg="6"
                      :xl="6">
                <el-form-item prop="projectSource">
                  <el-select v-model="queryForm.projectSource"
                             placeholder="请选择项目来源"
                             clearable
                             filterable>
                    <el-option v-for="item in resourceOptions"
                               :key="item.key"
                               :label="item.name"
                               :value="item.key"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </el-col>
    </el-row>
    <!--列表模块-->
    <el-row :gutter="20">
      <el-col :xs="24"
              :sm="24"
              :md="12"
              :lg="24"
              :xl="24">
        <el-card>
          <el-button :loading="downloadLoading"
                     type="primary"
                     @click="handleDownload">
            导出
          </el-button>
          <!--已处理工单列表-->
          <el-table ref="tableSort"
                    v-loading="listLoading"
                    :data="list"
                    stripe
                    style="margin-top: 15px"
                    border
                    :element-loading-text="elementLoadingText"
                    @selection-change="setSelectRows">
            <el-table-column type="selection"
                             width="40"
                             align="center"></el-table-column>
            <el-table-column label="工单编号"
                             prop="workOrderNo"
                             align="center"
                             width="130">
              <template slot-scope="scope">
                {{ scope.row.workOrderNo }}
              </template>
            </el-table-column>
            <el-table-column prop="targetSubject"
                             label="目标主体"
                             width="150"></el-table-column>
            <el-table-column label="目标地址"
                             min-width="250"
                             prop="address">
              <template slot-scope="scope">
                {{ scope.row.address || "-" }}
              </template>
            </el-table-column>
            <el-table-column label="项目"
                             prop="projectName"
                             width="150">
              <template slot-scope="scope">
                {{ scope.row.projectName || "-" }}
              </template>
            </el-table-column>
            <el-table-column label="工单状态"
                             prop="workOrderStatusValue"
                             width="90">
              <template slot-scope="scope">
                {{ scope.row.workOrderStatusValue || "-" }}
              </template>
            </el-table-column>
            <!-- 预约走访时间 -->
            <el-table-column prop="bookVisitTime"
                             label="预约走访时间"
                             width="130"
                             align="center"
                             sortable>
              <template slot-scope="scope">
                {{ scope.row.bookVisitTime || "-" }}
              </template>
            </el-table-column>
            <el-table-column prop="circulationTime"
                             label="流转日期"
                             align="center"
                             width="120">
              <template slot-scope="scope">
                {{ scope.row.circulationTime || "-" }}
              </template>
            </el-table-column>

            <el-table-column prop="nowUserName"
                             label="当前操作人"
                             align="center"
                             width="120">
              <template slot-scope="scope">
                {{ scope.row.nowUserName || "-" }}
              </template>
            </el-table-column>
            <el-table-column prop="firstAuditDateEnd"
                             label="初审结束日期"
                             align="center"
                             width="120">
              <template slot-scope="scope">
                {{ scope.row.firstAuditDateEnd || "-" }}
              </template>
            </el-table-column>

            <el-table-column prop="stepAndStranded"
                             align="center"
                             label="环节/整体滞留(天)"
                             width="90"
                             fit="true">
              <template slot-scope="scope">
                {{ scope.row.stepAndStranded || "-" }}
              </template>
            </el-table-column>
            <el-table-column prop="operStatusValue"
                             label="操作状态"
                             width="90px"
                             align="center">
              <template slot-scope="scope">
                {{ scope.row.operStatusValue || "-" }}
              </template>
            </el-table-column>
            <el-table-column label="操作"
                             width="120px"
                             fixed="right"
                             align="center">
              <template slot-scope="scope">
                <el-tooltip class="item"
                            effect="dark"
                            content="详情"
                            placement="top-start">
                  <el-button size="mini"
                             type="primary"
                             icon="el-icon-document"
                             circle
                             @click="handleReview(scope.row)"></el-button>
                </el-tooltip>
                <el-tooltip class="item"
                            effect="dark"
                            content="生成报告"
                            placement="top-start">
                  <el-button size="mini"
                             type="primary"
                             icon="el-icon-document-add"
                             circle
                             @click="handleReport(scope.row)"></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
    </el-row>

    <!--分页模块-->
    <el-row :gutter="20">
      <el-col :xs="24"
              :sm="24"
              :md="12"
              :lg="24"
              :xl="24">
        <el-card>
          <el-pagination :background="background"
                         :current-page="queryForm.pageNum"
                         :layout="layout"
                         :page-size="queryForm.pageSize"
                         :total="total"
                         @current-change="handleCurrentChange"
                         @size-change="handleSizeChange"></el-pagination>
        </el-card>
      </el-col>
    </el-row>

    <!--详情-->
    <review ref="review"
            dialog-title="工单详情"
            :preview="true"
            @refreshData="refreshData"></review>
  </div>
</template>

<script>
import review from "./review";
import { generateReport } from "@/api/workplace/commonOperation";
import { getDone } from "@/api/workplace/internalAudit/internalAudit";
import { mapGetters } from "vuex";
import {
  returnBitTimestamp,
  returnDeadtimestamp,
  getRoleKey,
  downloadReport,
} from "@/utils";
import {
  getBlock,
  getGeneralReason,
  getProjectSource,
  getRole,
  getAllReasonOption,
  getWorkOperStatus,
  getWorkOrderStatus,
  querySystemUsers,
  getReportTypeList,
} from "@/api/workplace/tools";

export default {
  name: "ComprehensiveTable",
  components: {
    review,
  },
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: "success",
        draft: "gray",
        deleted: "danger",
      };
      return statusMap[status];
    },
  },
  data() {
    return {
      isShow: false,
      imgShow: true,
      list: [],
      imageList: [],
      listLoading: true,
      layout: "total, sizes, prev, pager, next, jumper",
      total: 0,
      background: true,
      selectRows: "",
      elementLoadingText: "正在加载...",
      reportForm: {
        body: {},
        header: {
          currentTime: "",
          requestId: "1",
          sourceType: "site",
        },
      },
      queryForm: {
        circulationTime: [], // 表单数据，不传递到后端
        circulationTimeEnd: null,
        circulationTimeStart: null,
        workOrderNo: "",
        targetSubject: "",
        projectId: "",
        innerDeadDate: [], // 表单数据，不传递到后端
        expectVisitDate: [], // 表单数据，不传递到后端
        /** 后端最新变更走访日期参数 */
        clockStartTime: null,
        clockEndTime: null,
        workOrderStatus: "",
        surveyUser: "",
        innerDeadlineEnd: null,
        innerDeadlineStart: null,
        orderDate: [], // 表单数据，不传递到后端
        orderTimeEnd: null,
        orderTimeStart: null,
        userInfo: null, // 人员信息
        roleUser: null, // 选择人员参数

        operStatus: "",
        fallbackReasonId: "",

        address: "",

        pageNum: 1,
        pageSize: 10,
        nextUserNo: "",
        nextUserRoleNo: "",
        userNo: "",
        userRoleNo: "",
        firstAuditDate: [], //初审日期
        firstAuditDateEnd: null,
        firstAuditDateStart: null,
      },
      // 查询工单内审已处理的工单参数
      param: {
        body: {},
        header: {
          currentTime: "2020-09-09 12:12:12",
          requestId: "1",
          sourceType: "site",
        },
      },
      // 项目
      projectInfo: [],
      projectForm: {
        body: {
          source: "",
        },
        header: {
          currentTime: "",
          requestId: "123",
          sourceType: "site",
        },
      },
      //   角色人员
      roleOptions: [],
      roleOptions_arr: [],
      roleForm: {
        body: {},
        header: {
          currentTime: "",
          requestId: "123",
          sourceType: "site",
        },
      },

      cityInfo: [],
      cityForm: {
        body: {},
        header: {
          currentTime: "",
          requestId: "123",
          sourceType: "site",
        },
      },

      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },

      operStatus: [],

      allAbandonInfo: [],
      //  工单状态
      orderStatusOptions: [],

      // 退回原因form
      allBackForm: {
        body: {
          templateType: "",
        },
        header: {
          currentTime: "",
          requestId: "123",
          sourceType: "site",
        },
      },
      allAbandonForm: {
        body: {
          templateType: "",
        },
        header: {
          currentTime: "",
          requestId: "123",
          sourceType: "site",
        },
      },
      quitReasonOptions: [],

      isGiveBacks: [
        {
          value: 1,
          label: "是",
        },
        {
          value: 0,
          label: "否",
        },
      ],
      //  退回原因参数
      backReasonParam: {
        body: {
          templateTypeSeqId: "6694249429643431936",
        },
        header: {
          currentTime: "2020-09-09 12:12:12",
          requestId: "1",
          sourceType: "site",
        },
      },
      reasonOptions: [],
      // 操作状态
      operStatusInfo: [],
      operStatusForm: {
        body: {},
        header: {
          currentTime: "",
          requestId: "123",
          sourceType: "site",
        },
      },
      downloadLoading: false,
      staffInfo: [],
      staffForm: {
        body: {},
        header: {
          currentTime: "",
          requestId: "123",
          sourceType: "site",
        },
      },
      reportType: [], // 报告类型
      // 项目来源
      resourceOptions: [
        {
          name: "香港业务流程",
          key: "process_hk",
        },
        {
          name: "本地业务流程",
          key: "process_nd",
        },
        {
          name: "BR业务流程",
          key: "process_br",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      userNo: "user/userNo",
      roles: "user/roles",
    }),
  },
  created() {
    this.queryForm.userNo = this.userNo;
    this.queryForm.userRoleNo = getRoleKey("verify_people", this.roles);
  },
  beforeDestroy() {},
  mounted() {},
  methods: {
    /** 数据初始化 */
    handleInitData() {
      this.fetchData();
      // 获取项目
      this.getProject();

      // 获取人员选项
      this.getStaffInfo();
      // 获取报告类型
      this.getReportType();
    },
    /** 导出Excel */
    handleDownload() {
      if (this.selectRows.length > 0) {
        this.downloadLoading = true;
        import("@/vendor/ExportExcel").then((excel) => {
          const tHeader = [
            "工单编号",
            "订单编号",
            "目标主体",
            "目标地址",
            "项目",
            "报告类型",
            "二级类型",
            "工单状态",
            "预约走访时间",
            "流转日期",
            "当前操作人",
            "初审结束日期",
            "环节/整体滞留(天)",
            "操作状态",
          ];
          const filterVal = [
            "workOrderNo",
            "brWorkNo",
            "targetSubject",
            "address",
            "projectName",
            "reportType",
            "subReportType",
            "workOrderStatusValue",
            "bookVisitTime",
            "circulationTime",
            "nowUserName",
            "firstAuditDateEnd",
            "stepAndStranded",
            "operStatusValue",
          ];
          const list = this.selectRows;
          const data = this.formatJson(filterVal, list);
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: "工单列表",
            autoWidth: true,
            bookType: "xlsx",
          });
          this.downloadLoading = false;
        });
      } else {
        this.$baseMessage("未选中任何行", "error");
        return false;
      }
    },
    /** 组装导出数据 */
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          if (!v[j]) {
            return "——";
          }
          return v[j];
        })
      );
    },
    // 生成报告
    async handleReport(row) {
      this.reportForm.header.currentTime = returnBitTimestamp(new Date());
      this.reportForm.body.workOrderNo = row.workOrderNo;
      const { header } = await generateReport(this.reportForm);
      if (header.retCode === "1") {
        downloadReport(`/site/downOssAndTemp?workOrderNo=${row.workOrderNo}`);
      } else {
        this.$baseMessage(`${header.retMessage}`, "error");
      }
    },
    setSelectRows(val) {
      this.selectRows = val;
    },
    // 重置
    resetForm(formName) {
      if (this.$refs[formName] !== undefined) {
        // this.$refs[formName].resetFields();
        this.queryForm = this.$options.data().queryForm;
        this.reset = this.$options.data().reset;
      }
    },

    // 单个提交及批量提交
    handleSubmit(row) {
      // 单个提交
      this.$refs["submit"].showSubmit(row);
    },

    handleReview(row) {
      this.$refs["review"].showReview(row);
    },
    // 单个退回及批量退回
    handleWithdraw(row) {
      this.$refs["withdraw"].showWithdraw(row);
    },
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.queryForm.pageNum = val;
      this.fetchData();
    },
    heightQuery() {
      this.isShow = !this.isShow;
      // 获取工单状态
      this.getOrderStatus();
      // 获取角色列表
      this.getRoleList();
      // 获取地区
      this.getAddress();
      // 放弃原因
      this.getAllAbandon();
      //退回原因
      this.getAllBack();
      // 获取操作状态
      this.getOperStatus();
    },
    // 获取放弃原因 上门前放弃&上门后
    getAllAbandon() {
      this.allAbandonForm.header.currentTime = returnBitTimestamp(new Date());
      this.allAbandonForm.body.templateType = "80";
      getAllReasonOption(this.allAbandonForm).then((response) => {
        if ("1" === response.header.retCode) {
          this.allAbandonInfo = response.body;
        }
      });
    },
    async getNormalReason() {
      this.reasonOptions = Object.assign(
        {},
        (await getGeneralReason(this.backReasonParam)).body
      );
    },
    //add by peter.wei 20200911
    handleChange() {
      this.queryForm.addressProvince = this.queryForm.selectedOptions[0];
      this.queryForm.addressCity = this.queryForm.selectedOptions[1];
      this.queryForm.addressDistrict = this.queryForm.selectedOptions[2];
    },
    handleQuery() {
      this.queryForm.pageNum = 1;
      this.fetchData();
    },

    // 表格显色
    tableRowClassName({ row }) {
      // 到期时间小于3，行内高亮
      if (row.maturityDate <= 3) {
        return "warning-row";
      } else return "";
    },
    // 获取工单状态
    getOrderStatus() {
      this.param.header.currentTime = returnBitTimestamp(new Date());
      getWorkOrderStatus(this.param).then((response) => {
        if ("1" === response.header.retCode) {
          this.orderStatusOptions = response.body;
        } else {
          this.$message.error(
            `${response.header.retMessage},获取工单状态失败，请重新刷新页面`
          );
        }
      });
    },

    // 获取地区
    getAddress() {
      this.cityForm.header.currentTime = returnBitTimestamp(new Date());
      getBlock(this.cityForm).then((response) => {
        if ("1" === response.header.retCode) {
          let block_info = [];
          block_info.push(response.body[0]);
          this.cityInfo = block_info;
        } else {
          this.$message.error(
            `${response.header.retMessage},获取地区失败，请重新刷新页面`
          );
        }
      });
    },
    // 选择地区
    handleBlockChange(value) {
      this.queryForm.address = value.join(",");
    },
    // 获取项目
    getProject() {
      this.projectForm.header.currentTime = returnBitTimestamp(new Date());
      getProjectSource(this.projectForm).then((response) => {
        if ("1" === response.header.retCode) {
          this.projectInfo = response.body;
        }
      });
    },
    // 选择项目
    handleProjectChange(value) {
      if (value) {
        this.queryForm.projectId = value[1];
      }
    },
    getRoleList() {
      let role_arr = [];
      let roleForm = {
        body: [],
        header: {
          currentTime: "",
          requestId: "123",
          sourceType: "site",
        },
      };
      let roleOptions_arr = [];
      // 预约人员
      const bookUser = [
        {
          roleKey: "book_person",
        },
      ];

      // 调查人员
      const surveyUser = [
        {
          roleKey: "full_investigator",
        },
        {
          roleKey: "part_investigator",
        },
      ];

      // 督导人员
      const supervisor = [
        {
          roleKey: "supervisor",
        },
      ];

      // 用户
      const customer = [
        {
          roleKey: "customer",
        },
      ];
      role_arr.push(bookUser);
      role_arr.push(surveyUser);
      role_arr.push(supervisor);
      role_arr.push(customer);
      // 异步调用接口，使其按顺序执行
      async function getAsyncRole() {
        roleForm.header.currentTime = returnBitTimestamp(new Date());
        for (let index = 0; index < role_arr.length; index++) {
          roleForm.body = role_arr[index];
          await getRole(roleForm).then((response) => {
            if ("1" === response.header.retCode) {
              roleOptions_arr.push(response.body);
            } else {
              roleOptions_arr.push([]);
            }
          });
          if (index === role_arr.length - 1) {
            return roleOptions_arr;
          }
        }
      }
      getAsyncRole().then((res) => {
        this.roleOptions_arr = res;
      });
    },

    // 获取角色配置项
    getRoleOption(role) {
      switch (role) {
        case "bookUser":
          this.roleOptions = this.roleOptions_arr[0];
          break;
        case "surveyUser":
          this.roleOptions = this.roleOptions_arr[1];
          break;
        case "supervisor":
          this.roleOptions = this.roleOptions_arr[2];
          break;
        case "customer":
          this.roleOptions = this.roleOptions_arr[3];
          break;
        default:
          break;
      }
    },
    // 获取退回原因 普通退回+待定退回
    getAllBack() {
      this.allBackForm.header.currentTime = returnBitTimestamp(new Date());
      this.allBackForm.body.templateType = "81";
      getAllReasonOption(this.allBackForm).then((response) => {
        if ("1" === response.header.retCode) {
          this.reasonOptions = response.body;
        }
      });
    },
    // 获取操作状态
    getOperStatus() {
      this.operStatusForm.header.currentTime = returnBitTimestamp(new Date());
      getWorkOperStatus(this.operStatusForm).then((response) => {
        if (response.header.retCode === "1") {
          this.operStatus = response.body;
        } else {
          this.$message.error(
            `${response.header.retMessage},获取操作状态失败，请重新刷新页面`
          );
        }
      });
    },
    async fetchData() {
      this.listLoading = true;
      // 选择人员数据
      if (this.queryForm.userInfo && this.queryForm.userInfo.length > 0) {
        this.queryForm.roleUser = `${this.queryForm.userInfo[0]}:${this.queryForm.userInfo[1]}`;
      } else {
        this.queryForm.roleUser = "";
      }
      // 流转日期范围
      if (null !== this.queryForm.circulationTime) {
        if (0 < this.queryForm.circulationTime.length) {
          this.queryForm.circulationTimeStart = returnBitTimestamp(
            this.queryForm.circulationTime[0]
          );
          this.queryForm.circulationTimeEnd = returnDeadtimestamp(
            this.queryForm.circulationTime[1]
          );
        }
      } else {
        this.queryForm.circulationTimeStart = null;
        this.queryForm.circulationTimeEnd = null;
      }
      // 下单日期范围
      if (null !== this.queryForm.orderDate) {
        if (0 < this.queryForm.orderDate.length) {
          this.queryForm.orderTimeStart = returnBitTimestamp(
            this.queryForm.orderDate[0]
          );
          this.queryForm.orderTimeEnd = returnDeadtimestamp(
            this.queryForm.orderDate[1]
          );
        }
      } else {
        this.queryForm.orderTimeStart = null;
        this.queryForm.orderTimeEnd = null;
      }
      // 走访日期范围
      if (null !== this.queryForm.expectVisitDate) {
        if (0 < this.queryForm.expectVisitDate.length) {
          this.queryForm.clockStartTime = returnBitTimestamp(
            this.queryForm.expectVisitDate[0]
          );
          this.queryForm.clockEndTime = returnDeadtimestamp(
            this.queryForm.expectVisitDate[1]
          );
        }
      } else {
        this.queryForm.clockStartTime = null;
        this.queryForm.clockEndTime = null;
      }

      //firstAuditDateEnd
      // 初审截止日期范围
      if (null !== this.queryForm.firstAuditDate) {
        if (0 < this.queryForm.firstAuditDate.length) {
          this.queryForm.firstAuditDateStart = returnBitTimestamp(
            this.queryForm.firstAuditDate[0]
          );

          this.queryForm.firstAuditDateEnd = returnDeadtimestamp(
            this.queryForm.firstAuditDate[1]
          );
        }
      } else {
        this.queryForm.firstAuditDateStart = null;
        this.queryForm.firstAuditDateEnd = null;
      }

      // 内部截止日期范围
      if (null !== this.queryForm.innerDeadDate) {
        if (0 < this.queryForm.innerDeadDate.length) {
          this.queryForm.innerDeadlineStart = returnBitTimestamp(
            this.queryForm.innerDeadDate[0]
          );

          this.queryForm.innerDeadlineEnd = returnDeadtimestamp(
            this.queryForm.innerDeadDate[1]
          );
        }
      } else {
        this.queryForm.innerDeadlineStart = null;
        this.queryForm.innerDeadlineEnd = null;
      }
      this.queryForm.userNo = this.userNo;
      this.queryForm.userRoleNo = getRoleKey("verify_people", this.roles);
      this.param.body = Object.assign({}, this.queryForm);
      const { body } = await getDone(this.param);
      this.list = body.records;
      this.total = body.total;
      this.$emit("update:done-val", this.total);
      this.listLoading = false;
    },
    // 打开工单单详情页面
    goDetailPage() {
      this.$router.push("/workplace/supervision/recommend/detail");
    },
    // 获取人员信息
    async getStaffInfo() {
      this.staffForm.header.currentTime = returnBitTimestamp(new Date());
      const { header, body } = await querySystemUsers(this.staffForm);
      if (header.retCode === "1") {
        this.staffInfo = body;
      }
    },
    // 选择人员数据框改变值
    handleSatffChange(value) {
      if (value) this.queryForm.userInfo = value;
    },
    // 获取报告分类
    getReportType() {
      getReportTypeList(this.projectForm).then((response) => {
        if (response.header.retCode === "1") {
          this.reportType = response.body;
        }
      });
    },
  },
};
</script>
<style scoped>
.el-col {
  margin-bottom: 10px;
}
.el-col :last-child {
  margin-bottom: 0;
}

.el-date-editor--daterange.el-input,
.el-date-editor--daterange.el-input__inner,
.el-date-editor--timerange.el-input,
.el-date-editor--timerange.el-input__inner {
  width: 100%;
}

.el-select,
.el-cascader {
  width: 100%;
}
.my-form-class {
  margin-bottom: -10px !important;
}
</style>
<style>
.my-back-img {
  width: 20px;
  height: 20px;
  position: absolute;
  top: 4px;
  left: 2px;
}
.el-dropdown-menu__item {
  padding: 0;
}
</style>
